export default "__VITE_PUBLIC_ASSET__f260bf4a__"